import { inject, injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { AddressRepo } from "../address.repo";
import { TableRepo } from "../table.repo";
import { UnitTypeModel } from "@/core/models/unit-type/unit-type.model";
import { FeeLadderRepo } from "./fee-ladder.repo";

interface _UnitTypeGetParams {
    search?: string
    provinceId?: string
    districtId?: string
    wardId?: string
}

@injectable()
export class UnitTypeRepo extends TableRepo<UnitTypeModel> {
    @inject(AddressRepo)
    private addressRepo!: AddressRepo;

    @inject(FeeLadderRepo)
    private feeLadderRepo!: FeeLadderRepo;

    constructor() {
        super("/api/UnitType");
    }

    async getData(index: number, params: _UnitTypeGetParams, pageSize = 10): Promise<ApiPage<UnitTypeModel>|null> {
        const result = await super.getData(index, params, pageSize)
        const feeLadders = await this.feeLadderRepo.getAll();
        if (result) {
            const data: UnitTypeModel[] = [];
            for (const record of result.data) {
                const [province] = await Promise.all([
                    this.addressRepo.getProvince(record.provinceId),
                ])
                const populatedRecord: UnitTypeModel = {
                    ...record,
                    provinceName: province?.name,
                    feeLadder: feeLadders.find(ladder => ladder.id === record.feeLadderId)
                };
                data.push(populatedRecord);
            }
            result.data = data;
            return result;
        }
        return null;
    }
}